import _regeneratorRuntime from "/client/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/client/node_modules/@babel/runtime/helpers/esm/inherits";
import fetch from "cross-fetch";
import { Base } from "@logtail/core"; // Awaiting: https://bugs.chromium.org/p/chromium/issues/detail?id=571722
// import { getUserAgent } from "./helpers";

export var Browser =
/*#__PURE__*/
function (_Base) {
  _inherits(Browser, _Base);

  function Browser(sourceToken, options) {
    var _this;

    _classCallCheck(this, Browser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Browser).call(this, sourceToken, options)); // Sync function

    var sync =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(logs) {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(_this._options.endpoint, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer ".concat(_this._sourceToken) // Awaiting: https://bugs.chromium.org/p/chromium/issues/detail?id=571722
                    // "User-Agent": getUserAgent()

                  },
                  body: JSON.stringify(logs)
                });

              case 2:
                res = _context.sent;

                if (!res.ok) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", logs);

              case 5:
                throw new Error(res.statusText);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function sync(_x) {
        return _ref.apply(this, arguments);
      };
    }(); // Set the throttled sync function


    _this.setSync(sync);

    return _this;
  }

  return Browser;
}(Base);